import React, { Component } from 'react';
import { observer } from 'mobx-react';
import autoBindMethods from 'class-autobind-decorator';

import { FormModal } from '../../../lib/mighty-fields';
import { ILoanAccountContact } from '../../../interfaces';

import { CONTACT_FIELD_SETS } from './FieldSets';

interface IProps {
  // The name typed into the search step when creating, the whole contact when editing
  contact?: Partial<ILoanAccountContact>;
  isEditing?: boolean;
  onClose: () => void;
  onSave: (data: object) => Promise<void>;
}

/**
 * The contact's own details. Shared by the add flow's second step and by the row's Edit, the two
 * differing only in what fills the form and what the buttons say.
 */
@autoBindMethods
@observer
class ContactFormModal extends Component<IProps> {
  public render () {
    const { contact, isEditing, onClose, onSave } = this.props;

    return (
      <FormModal
        className='modal-loan-account-contact'
        fieldSets={CONTACT_FIELD_SETS}
        model={contact || {}}
        onClose={onClose}
        onSave={onSave}
        saveText={isEditing ? 'Save' : 'Add Contact'}
        title={isEditing ? 'Edit Contact' : 'Add New Contact'}
      />
    );
  }
}

export default ContactFormModal;
